module.exports = __webpack_public_path__ + "img/grey_006.d12cceb8.png";